export var HEADER_NAVIGATION_ACTION_CLASS_PREFIX = 'HeaderNavigationAction';
export var headerNavigationActionRoot = 'HeaderNavigationActionRoot';
export var headerNavigationActionItemRoot = 'HeaderNavigationActionItemRoot';